import { Check } from 'lucide-react';
import { WHY_US } from '@/constants/content';

export default function WhyChoose() {
    return (
        <section className="section-pad bg-white">
            <div className="container-wl">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
                    <div className="lg:col-span-5">
                        <div className="flex items-center gap-3 mb-5">
                            <span className="gold-rule" />
                            <span className="overline">Why Waylthlane</span>
                        </div>
                        <h2 className="font-display-bold text-ink text-4xl lg:text-[52px] leading-[1.05] tracking-tight">
                            Six reasons clients stay <span className="italic text-gold-600">for decades.</span>
                        </h2>
                        <p className="mt-5 text-ink/65 text-[16px] leading-relaxed">
                            Trust is built quietly — through consistency, transparency and decisions made
                            in your interest. Here is what that looks like in practice.
                        </p>
                    </div>

                    <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-hairline border border-hairline rounded-xl overflow-hidden">
                        {WHY_US.map((w) => (
                            <div key={w.title} className="bg-white p-7 hover:bg-soft transition-colors duration-500">
                                <div className="w-9 h-9 flex items-center justify-center bg-forest text-white">
                                    <Check className="w-4 h-4" strokeWidth={2.5} />
                                </div>
                                <h3 className="font-display-bold text-ink text-[20px] mt-5">{w.title}</h3>
                                <p className="mt-2 text-[14px] text-ink/65 leading-relaxed">{w.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
